/**
 * Outbound links whose destination we may need to change without shipping a
 * new desktop build.
 *
 * The Chrome Web Store listing id is the reason this file exists: it is not
 * ours to keep stable (unlisting and relisting mints a new one), and every
 * build already installed keeps whatever URL it was compiled with. So the app
 * links a redirect on the API — `/extensions/chrome` — whose target is an
 * admin setting ("Chrome Extension URL"). One paste in admin repoints the
 * desktop app, the vault hint and both websites at once.
 *
 * The base is read from the same env var the API services use, so a staging
 * build follows its own backend's setting rather than production's.
 */
const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'https://api.apiboo.com/api/v1').replace(
  /\/$/,
  ''
);

export const CHROME_EXTENSION_URL = `${API_BASE}/extensions/chrome`;

/**
 * The web vault (card 6.2): reads the encrypted cloud copy in the browser.
 * Its own host, never an API redirect: the address a person types and checks
 * is the one that must never change.
 */
export const VAULT_WEB_URL = 'https://vault.apiboo.com';
